import { FiArrowLeft } from 'react-icons/fi';
import { createIconComponent } from '../createIconComponent';

export const ArrowLeft = createIconComponent(FiArrowLeft);
